import { Component, Input } from '@angular/core';
import { Building, BUILDING_STATUS } from '../model/building.model';
import { BatchNextControlDateEditDialogComponent } from '../batch-next-control-date-edit-dialog/batch-next-control-date-edit-dialog.component';
import { updateNextControlDates, updateEgids } from '../store/building.action';
import { DialogService } from '../../shared/service/dialog.service';
import { Store } from '@ngrx/store';
import { DatePipe, NgStyle, AsyncPipe } from '@angular/common';
import { selectHasPolicy } from '../../authentication/store/user.selector';
import { selectIsBuildingStatusEnabled } from '../../features/store/feature-flags.selector';
import { BatchEgidEditDialogComponent } from '../batch-egid-edit-dialog/batch-egid-edit-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { LinkButtonComponent } from '../../shared/buttons/link-button.component';
import { JoinPipe } from '../../shared/array.pipe';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-building-info',
  templateUrl: 'building-info.component.html',
  styleUrls: ['building-info.component.scss'],
  imports: [MatIcon, NgStyle, LinkButtonComponent, JoinPipe, TranslocoPipe, AsyncPipe, DatePipe],
  providers: [DatePipe],
})
export class BuildingInfoComponent {
  @Input() building: Building;
  @Input() section: 'titleMO' | 'titleSibat' = 'titleMO'; // Add this line
  canEditNextControlDate$ = this.store.select(selectHasPolicy('building.nextControlDate.edit'));
  canEditEgid$ = this.store.select(selectHasPolicy('building.egid.edit'));
  isBuildingStatusEnabled$ = this.store.select(selectIsBuildingStatusEnabled);
  readonly buildingStatus = BUILDING_STATUS;

  constructor(private dialogService: DialogService, private datePipe: DatePipe, private store: Store) {}

  async editNextControlDate() {
    let existingDate;
    if (this.building.nextControlDate) {
      existingDate = this.datePipe.transform(this.building.nextControlDate, 'dd.MM.yyy');
    }
    const nextControlDate = await this.dialogService.openDialogComponentAsync<string | null>(BatchNextControlDateEditDialogComponent, {
      count: 1,
      existingDate,
    });

    if (nextControlDate || nextControlDate === null) {
      this.store.dispatch(
        updateNextControlDates({
          buildingIds: [this.building.id],
          date: nextControlDate,
        })
      );
    }
  }
  getTextColor(color: string | undefined): string {
    switch (color) {
      case 'vert':
        return 'green';
      case 'rouge':
        return 'red';
      default:
        return 'inherit';
    }
  }

  editEgid() {
    this.dialogService.openDialogComponentAsync<number[]>(BatchEgidEditDialogComponent, { egids: this.building.egids }).then(result => {
      if (!result) {
        return;
      }

      this.store.dispatch(
        updateEgids({
          buildingId: this.building.id,
          egids: result,
        })
      );
    });
  }
}
